<div class="dashboard-panel-header">
    <div
        data-cy="dashboard-tab-header-title"
        class="highlighted-text subtitle-smaller title"
    >
        <span>{{ title }}</span>
    </div>

    <div *ngIf="!isPreview">
        <div
            data-cy="dashboard-tab-header-remove-button"
            class="highlighted-text menu-option"
            [ngClass]="{
                text: !responsive.isSmall() && !responsive.isXSmall(),
                'text-xsmall': responsive.isXSmall() || responsive.isSmall()
            }"
            (click)="handleDeleteClicked()"
        >
            <mat-icon svgIcon="delete"></mat-icon>
            <span> {{ "dashboard.panel.labels.delete" | translate }}</span>
        </div>
    </div>
</div>
